import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';

import { renderNode } from '../../helpers';
import { ModalSheet } from './ModalSheet';
import { ModalSheetPane } from './ModalSheetPane';
import { ModalSheetHeader } from './ModalSheetHeader';
import { useControlledModalSheet } from './useControlledModalSheet';

export const PortalModalSheet = ({
    title,
    render,
    portalTo,
    padding,
    onClosing,
    onClose: onClose2,
    closeIcon,
    rightButton,
    children,
    className,
    ...rest
}) => {
    const { isClosing, onClose, onExit } = useControlledModalSheet({ onClosing, onClose: onClose2 });
    const handleTrue = useCallback(() => void onClose(true), [onClose]);
    const handleFalse = useCallback(() => void onClose(false), [onClose]);

    return createPortal(
        <ModalSheet isClosing={isClosing} onClose={onClose} onExit={onExit} {...rest}>
            <ModalSheetPane
                className={className}
                padding={padding}
                header={
                    (title || closeIcon) && (
                        <ModalSheetHeader
                            title={title}
                            closePath={onClose}
                            closeIcon={closeIcon}
                            rightButton={renderNode(rightButton, onClose)}
                        />
                    )
                }
            >
                {renderNode(render || children, { handleClose: onClose, handleTrue, handleFalse })}
            </ModalSheetPane>
        </ModalSheet>,
        document.querySelector(portalTo)
    );
};

PortalModalSheet.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.element]),
    closeIcon: PropTypes.elementType,
    rightButton: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.bool]),
    render: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element]),
    portalTo: PropTypes.string.isRequired,
    padding: PropTypes.bool,
    onClosing: PropTypes.func,
    onClose: PropTypes.func,
    paneMotionProps: PropTypes.object,
};

PortalModalSheet.defaultProps = {
    padding: true,
    portalTo: '#mainRoot',
};
